module.exports = __webpack_public_path__ + "static/media/11NEPAD12.00a46f00.jpg";